import React from 'react';
import { FormattedText, formatText } from 'core/i18n';
import Storage from 'utilities/storage';
import MessagesScreen from 'components/messagesScreen/messagesScreen';
import { PUBLICA_URL } from 'constants/index';

const CallCenterKOMessages = () => {
    const messagesScreenAction = () => {
        Storage.cookies.remove('accessToken');
        Storage.cookies.remove('refreshToken');
        window.location.href = PUBLICA_URL;
    };
    return (
        <div className="main-container messages-main-container basic-layering">
            <MessagesScreen
                iconClass="icons icons--icon-clock-type-2"
                title={formatText('messagesScreen-identityVerificationInProcessTitle')}
                buttonText={formatText('button-understood')}
                buttonClass="form__button form__button-secondary"
                action={messagesScreenAction}
            >
                <FormattedText value="messagesScreen-identityVerificationInProcessContent" />
            </MessagesScreen>
        </div>
    );
};

export default CallCenterKOMessages;
